import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ViewportSizeProvider } from '../../context/viewport-size-context';
// import { UserDataProvider, userDataContext } from '../../contexts/user-data-context';
// import CommonUtility from '../UtilityService/CommonUtility';
import Navbar from '../Navbar/index.jsx';
import Footer from '../Navbar/footer.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary.jsx';
import ScrollToTop from '../Components/ScrollToTop/index.js';
// import userDetails from '../APIService/userDetails.js';

export default function Layout() {
    const location = useLocation();
    const navigate = useNavigate();
    const [hasError, setHasError] = useState(false);
    // const { setUserData } = useContext(userDataContext);
    useEffect(() => {
        const { pathname } = location;

        if (['/', ''].includes(pathname)) navigate('/home');
    }, [location, navigate]);

    return (
        <ViewportSizeProvider>
            <ScrollToTop />
            <Navbar />
            <ErrorBoundary hasError={hasError} setHasError={setHasError}>
                <Outlet />
            </ErrorBoundary>
            <Footer />
        </ViewportSizeProvider>
    );
}
